module.exports = __webpack_public_path__ + "img/service-doctor.867a5efd.jpg";